<agpr-take-over-panel
    [id]="id"
    header="Briefings.manageDigestDialog.heading"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="1000"
    [maxPanelWidth]="1300"
>
    <div class="agpr-manageDigestDialog-content">
        <div class="agpr-manageDigestDialog-list">
            <agpr-scroll-panel class="agpr-manageDigestDialog-list-scrollPanel">
                <agpr-table
                    [id]="id + '_existingDigestTable'"
                    [columns]="columnDefs"
                    [sortColumn]="nameColumn"
                    [sortAscending]="true"
                    [(ngModel)]="digestRows"
                    (ngModelChange)="checkForSelectedFeeds()"
                    (itemChanged)="updateDigest($event)"
                    noContentMessage="Briefings.manageDigestDialog.noContentMessage"
                ></agpr-table>
            </agpr-scroll-panel>
        </div>
    </div>
    <ng-template #takeOverFooterRight>
        @if (hasSelectedDigests) {
            <agpr-button
                [id]="id + '_deleteButton'"
                label="Briefings.manageDigestDialog.deleteButton"
                [style]="buttonTypes.primaryB"
                (click)="deleteDigests()"
            ></agpr-button>
        }
        <agpr-button
            [id]="id + '_createButton'"
            class="agpr-manageDigestDialog-createDigest"
            label="Briefings.manageDigestDialog.create"
            [style]="buttonTypes.primaryB"
            (click)="createDigest()"
        ></agpr-button>

        <agpr-button
            [id]="id + '_closeButton'"
            label="Briefings.manageDigestDialog.done"
            [style]="buttonTypes.primary"
            (click)="hideSlideOverlay = true;"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>

<ng-template let-row="row" let-column="column" #customActionsCell>
    <div class="agpr-manageDigestDialog-customCell">
        <agpr-split-button
            class="agpr-manageDigestsDialog-splitButton"
            [style]="buttonTypes.icon"
            [showTriggerIcon]="false"
            icon='fa-light fa-ellipsis-vertical'
            [options]="digestActions"
            panelPositionX="left"
            (mouseenter)="actionOnRow(row)"
        ></agpr-split-button>
    </div>
</ng-template>